import React from "react";

export function TransactionTableSkeletonLoader() {
	return (
		<div className="skeleton__table table table--bordered table--shadowy u-mar--top--xsml">
			{Array.from({ length: 16 }).map((_, i) => (
				<div
					key={i}
					className="skeleton__box skeleton__table__box u-padd--big"
				/>
			))}
		</div>
	);
}
